import { Injectable, computed, signal } from '@angular/core';
import { Restaurant } from 'src/interfaces/restaurant.model';
import { Locale } from 'src/interfaces/locale.model';
import { Table } from 'src/interfaces/table.model';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private localeSignal = signal<Locale | null>(null);
  private tableId = signal<string | null>(null);
  private table = signal<Table | null>(null);

  /**
   * Заказ возможен только со столом: стол заведения по QR или виртуальный
   * демо-стол. Ссылка заведения (slug, id) без стола — только просмотр меню:
   * без количества, «Добавить», корзины и заказа. У промо-заведения стола
   * нет никогда (menu-homepage)
   */
  canOrder = computed(() => this.table() !== null);

  // Сигнал для отслеживания завершения рендеринга списка
  isListRendered = signal<boolean>(false);

  restaurant: Restaurant | null = null;
  language: string = 'ru';
  guestId: string = '';
  agreement = true;

  // Чаевые
  tipAmount: number = 0;

  // Геттеры и сеттеры для сигналов
  set locale(locale: Locale | null) {
    this.localeSignal.set(locale);
  }

  get locale(): Locale | null {
    return this.localeSignal();
  }

  // Метод для установки состояния рендеринга
  setListRendered(isRendered: boolean): void {
    // Устанавливаем состояние рендеринга
    console.log('DataService | setListRendered | isRendered:', isRendered);
    this.isListRendered.set(isRendered);
  }

  getTableId(): string | null {
    return this.tableId();
  }

  setTableId(tableId: string | null): void {
    this.tableId.set(tableId);
  }

  getTable(): Table | null {
    return this.table();
  }

  setTable(table: Table | null): void {
    this.table.set(table);
  }
}
